import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { WhitelabeledComponentKey } from '../../../../../whitelabel/whitelabel-component-types';
import { SidebarState } from '../../../../osp-ui/components/sidebar/contract/sidebar-state.contract';
import { BaseSidebarStateDirective } from '../../../../osp-ui/components/sidebar/directives/base-sidebar-state.directive';
import { WhitelabeledComponent } from '../../../../whitelabel/components/whitelabeled-component/whitelabeled-component.component';
import { SidebarWrapperComponent } from '../sidebar/sidebar-wrapper.component';
import { TopbarComponent } from '../topbar/topbar.component';

@Component({
  selector: 'osp-dashboard-layout',
  standalone: true,
  imports: [WhitelabeledComponent, TopbarComponent, NgClass],
  templateUrl: './dashboard-layout.component.html',
  styleUrl: './dashboard-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardLayoutComponent {
  $sidebarState = signal(BaseSidebarStateDirective.DEFAULT_STATE);
  sidebarProps = {
    registerOnStateChange: (state: SidebarState) => this.$sidebarState.set(state),
  };

  protected readonly WhitelabeledComponentKey = WhitelabeledComponentKey;
  protected readonly SidebarComponent = SidebarWrapperComponent;
}
